import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ px })=>({
        image: {
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover'
        },
        small: {
            width: px(40),
            height: px(40)
        },
        medium: {
            width: px(64),
            minWidth: px(64),
            height: px(64)
        },
        large: {
            width: px(120),
            minWidth: px(120),
            height: px(120)
        }
    }));
export { useStyles };
